import { QuestionList } from './types/question-list';
import { RequiredTools } from './types/required-tools';

export class Questionnaire<
  TData extends object,
  TUserInputTools,
  TId extends string = string
> {
  constructor(
    private readonly _createQuestionList: (
      tools: TUserInputTools & RequiredTools<TData, TId>
    ) => QuestionList<TId>
  ) {}

  withTools = (
    tools: TUserInputTools & RequiredTools<TData, TId>
  ): QuestionList<TId> => this._createQuestionList(tools);
}
